import { deburr } from 'lodash';
import { isBlank } from '@seedlang/utils';

function removePunctuation(string) {
  return string.replace(/\p{P}/gu, '').replace(/\s+/g, ' ').replace(/\s+$/g, '');
}

/**
 * Compares two strings based on the specified sensitivity
 * @param {string} value1 - The first string to compare
 * @param {string} value2 - The second string to compare
 * @param {'case'|'specialCharacters'|'punctuation'} sensitive - The type of sensitivity to check
 * @returns {boolean} - Whether the strings differ based on the specified sensitivity
 */
function compare(value1, value2, sensitive) {
  let transformedValue1 = value1;
  let transformedValue2 = value2;

  if (sensitive !== 'case') {
    transformedValue1 = transformedValue1.toLowerCase();
    transformedValue2 = transformedValue2.toLowerCase();
  }

  if (sensitive !== 'specialCharacters') {
    transformedValue1 = deburr(transformedValue1);
    transformedValue2 = deburr(transformedValue2);
  }

  if (sensitive !== 'punctuation') {
    transformedValue1 = removePunctuation(transformedValue1);
    transformedValue2 = removePunctuation(transformedValue2);
  }

  return transformedValue1 === transformedValue2;
}

export function sameWithoutCaseAccentsAndPunctuation(value1, value2) {
  return compare(value1, value2);
}

export function compareSubmittedValueWithSolution(submittedValue, solution) {
  return {
    incorrectCasing: !compare(submittedValue, solution, 'case'),
    incorrectSpecialCharacters: !compare(submittedValue, solution, 'specialCharacters'),
    incorrectPunctuation: !compare(submittedValue, solution, 'punctuation'),
  };
}

export function underlineWronglyPositionedCharacters(solution, submittedValue) {
  if (isBlank(solution) || isBlank(submittedValue)) {
    return '';
  }

  return solution.trim().split('')
    .map(
      (char, index) => char !== submittedValue.trim()[index] ? `<u>${char}</u>` : char,
    ).join('');
}